// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--aZg1R","wave":"styles-module--wave--hU1Cg"};